import _objectSpread from "E:\\workspace\\\u6C9B\u57CE\\pcweb\\node_modules\\@babel\\runtime/helpers/esm/objectSpread";
import "core-js/modules/es6.object.assign";
import _toConsumableArray from "E:\\workspace\\\u6C9B\u57CE\\pcweb\\node_modules\\@babel\\runtime/helpers/esm/toConsumableArray";
import "core-js/modules/es6.regexp.search";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import packageTableMixins from "@/mixins/packageTableMixins.js";
import addCom from "./components/addCom";
import uploadsnCom from "./components/uploadsnCom"; //import config from '@/config/index'

import { area_list, area_add, area_update, area_del, getdownloadtoken } from "@/api/jingxiaoshang";
import axios from "@/libs/api.request";
import config from '@/config/index';
import { get_table_data, add_table_data, del_table_data, download_life, get_token, sn_file_log, get_project_listinfo as _get_project_listinfo, get_import_sn_did, import_sn } from "@/api/chuku";
export default {
  name: "areaClass",
  mixins: [packageTableMixins],
  data: function data() {
    var _this2 = this;

    return {
      project_codeData: [],
      cateList: [],
      nodeList: [],
      showSearchMore: false,
      form_filter: {
        cate_name: null
      },
      //共用的右侧添加按钮
      topButtonList1: [{
        name: this.$t("productModule.guanliansn"),
        type: "primary",
        method: this.add
      }],
      topButtonList: [{
        name: this.$t("query"),
        type: "primary",
        method: this.search
      }, {
        name: this.$t("reset"),
        type: "error",
        method: this.reset
      }],
      searchReq: {
        mods: []
      },
      tableData: [],
      columnsData: [// {
      //   title: this.$t("serialnumber"),
      //   key: "id",
      //   align: "center",
      //   width: 80,
      // },
      {
        title: this.$t("filename"),
        key: "file_name",
        align: "left",
        minWidth: 120,
        tree: true
      }, {
        title: this.$t("productModule.projectcode"),
        key: "project_code",
        align: "left",
        minWidth: 120,
        tree: true
      }, {
        title: this.$t("uploadtime"),
        key: "addtime",
        align: "left",
        minWidth: 120,
        tree: true
      }, {
        title: this.$t("operation"),
        key: "explain",
        align: "center",
        width: 300,
        render: function render(h, _ref) {
          var row = _ref.row;
          var arr = [];
          arr.push(h("Button", {
            style: {
              marginRight: "3px",
              marginBottom: "3px",
              color: "#fff"
            },
            props: {
              size: "small",
              type: "primary"
            },
            on: {
              click: function click() {
                _this2.downhexCsv(row, 1);
              }
            }
          }, _this2.$t("productModule.exportsn")));
          arr.push(h("Button", {
            style: {
              marginRight: "3px",
              marginBottom: "3px",
              color: "#fff"
            },
            props: {
              size: "small",
              type: "primary"
            },
            on: {
              click: function click() {
                _this2.downhexCsv(row, 2);
              }
            }
          }, _this2.$t("productModule.exportasr")));
          return h("div", arr);
        }
      }],
      tableLoading: false,
      tabletotallen: 0,
      border: true,
      stripe: true,
      moduleShow: false,
      addBase: {
        name: "",
        code: "",
        state: "",
        explain: ""
      },
      reqBase: {
        page: 1,
        page_size: 10,
        type: 3
      },
      states: [{
        value: 0,
        label: "禁用"
      }, {
        value: 1,
        label: "启用"
      }],
      modalTitle: true,
      ruleValidate: {
        name: [{
          required: true,
          message: "请输入模块名",
          trigger: "blur"
        }],
        code: [{
          required: true,
          message: "请输入模块代码",
          trigger: "change"
        }],
        explain: [{
          required: true,
          message: "请输入说明",
          trigger: "blur"
        }],
        state: [{
          required: true,
          message: "请选择状态",
          trigger: "change"
        }]
      }
    };
  },
  components: {},
  computed: {
    modelList: function modelList() {
      return this.$store.state.authCenter.ModuleData;
    },
    getRoot: function getRoot() {
      var root = '';

      if (process.env.NODE_ENV === 'development') {
        root = config.baseUrl.dev;
      } else if (process.env.VUE_APP_BUILD === 'production') {
        root = config.baseUrl.pro;
      } else {
        root = config.baseUrl.alp;
      }

      return root;
    }
  },
  methods: {
    //     getDownloadCsv(){
    //       let result;
    //       if(process.env.NODE_ENV === 'development'){
    //         result=config.baseImgUrl.dev+product.download_csv_file;
    //       }else if(process.env.VUE_APP_BUILD === 'production'){
    //         result=config.baseImgUrl.pro+product.download_csv_file;
    //       }else{
    //         result=config.baseImgUrl.alp+product.download_csv_file;
    //       }
    //       return result;
    //  },    
    //下载csv
    downhexCsv: function downhexCsv(row, type) {
      var vm = this;
      var title = "";
      var info = "";

      if (type == 1) {
        title = this.$t('productModule.exportsn');
        info = "did_sn ";
      } else {
        title = this.$t('productModule.exportasr');
        info = "special_sn";
      }

      var content = this.$t('productModule.exportholder');
      var config = {
        title: title,
        loading: true,
        content: content,
        onOk: function onOk() {
          var _this = this; //导出接口


          var params1 = {
            downloadinfo: info,
            code: '123'
          }; // getdownloadtoken(params1).then((res) => {
          //   callbak(res);
          // });
          //提交请求
          // vm.$store.dispatch("product/handlegetdownloadtoken",{
          //   downloadinfo:row.did_sn,
          //   po:"special_sn",
          // }).then(res=>{ 

          getdownloadtoken(params1).then(function (res) {
            if (res.result === 0) {
              vm.$Message.success(res.errorMsg);
              var url = vm.getRoot;
              console.log("url", url);

              if (type == 1) {
                url += "/index.php/admin/product/get_excel?type=did_sn&downloadtoken=" + res.body.downloadtoken + "&id=" + row.id + "&filetype=1";
              } else {
                url += "/index.php/admin/product/download_csv_file?jinzhi=rsa&model_code=" + row.model_code + "&po=special_sn&downloadtoken=" + res.body.downloadtoken + "&id=" + row.id + "&filetype=3";
              } // console.log("url111", url)
              // return;


              window.open(url);
              vm.$Modal.remove();
            } else {
              vm.$Message.error(res.errorMsg);
              _this.buttonLoading = false;
            }
          });
        }
      };
      this.$Modal.confirm(config);
    },
    get_project_listinfo: function get_project_listinfo() {
      var _this3 = this;

      _get_project_listinfo({}).then(function (res) {
        var msg = res.errorMsg;

        if (res.result === 0) {
          _this3.project_codeData = res.body; //this.inverter_typeData=res.body.inverter_type
        } else {
          vm.$Message.error(msg);
          _this.buttonLoading = false;
        }
      });
    },
    handleLoadData: function handleLoadData(item, callback) {
      console.log("11111");
      var vm = this;

      var callbak = function callbak(res) {
        if (res.result === 0) {
          var data = res.body.list || [];

          for (var i in data) {
            var list = data[i];

            if (list.has_child === 1) {
              list._loading = false;
              list.children = [];
              list.parent_code = item.area_code;
              list.parent_name = item.area_name;
            }
          }

          callback(data);
        } else {}
      };

      area_list({
        page_size: -1,
        page: 1,
        parent_code: item.area_code,
        all: 1 // project_code:vm.projectCode,
        // parent_code:item.cate_code

      }).then(function (res) {
        callbak(res);
      }).catch(function (err) {// this.tableLoading=false;
      });
    },
    createTree: function createTree(data) {
      for (var i in data) {
        var list = data[i];
        list["value"] = list.node_code;
        list["label"] = list.node_name;

        if (list.children && list.children.length > 0) {
          this.createTree(list.children);
        }
      }
    },
    createTree1: function createTree1(data) {
      for (var i in data) {
        var list = data[i];
        list["value"] = list.cate_code;
        list["label"] = list.cate_name;

        if (list.children && list.children.length > 0) {
          this.createTree1(list.children);
        }
      }
    },
    getTreeCateNodeData: function getTreeCateNodeData(callback) {
      var _this4 = this;

      this.spinShow = true;
      this.cateList.splice(0);
      patrolcateGetAllCate({
        project_code: this.$store.state.user.projectCode
      }).then(function (res) {
        _this4.spinShow = false;

        if (res.result === 0) {
          var _this4$cateList;

          var data = res.body;

          _this4.createTree1(data);

          (_this4$cateList = _this4.cateList).push.apply(_this4$cateList, _toConsumableArray(data));

          if (callback) {
            callback(_this4.cateList);
          }
        } else {}
      });
    },
    getTreeNodeData: function getTreeNodeData(callback) {
      var _this5 = this;

      this.spinShow = true;
      this.nodeList.splice(0);
      get_all_cate({
        project_code: this.$store.state.user.projectCode
      }).then(function (res) {
        _this5.spinShow = false;

        if (res.result === 0) {
          var _this5$nodeList;

          var data = res.body;

          _this5.createTree(data);

          (_this5$nodeList = _this5.nodeList).push.apply(_this5$nodeList, _toConsumableArray(data));

          if (callback) {
            callback(_this5.nodeList);
          }
        } else {}
      });
    },

    /**
     * 修改状态
     */
    changeStatus: function changeStatus(row, title) {
      var _this6 = this;

      var _this = this;

      var config = {
        loading: true,
        title: title,
        width: 400,
        content: "<p>\u60A8\u786E\u8BA4\u8981".concat(title, "<span style=\"color: #f60;\">").concat(row.plan_name, "</span>\uFF1F</p>"),
        onOk: function onOk() {
          var params = {
            plan_code: row.plan_code
          },
              callbak = function callbak(req) {
            if (req.result === 0) {
              _this6.$Message.success(req.errorMsg);

              _this6.$Modal.remove();

              _this6.init();
            } else {
              _this6.buttonLoading = false;

              _this6.$Message.error(req.errorMsg);
            }
          }; //删除接口


          handle_catch_fear_status(params).then(function (res) {
            callbak(res);
          });
        }
      };
      this.$Modal.confirm(config);
    },
    showMore: function showMore() {
      if (!this.showSearchMore) {
        this.showSearchMore = true;
      } else {
        this.showSearchMore = false;
      }
    },
    init: function init() {
      this.getPageSizeToStorage();
      this.getData();
      this.get_project_listinfo();
    },

    /**
     * 初始化数据
     */
    getData: function getData() {
      var _this7 = this;

      this.tableData.splice(0);
      this.tableLoading = true;
      var vm = this;

      var callbak = function callbak(res) {
        _this7.tableLoading = false;

        if (res.result === 0) {
          var data = res.body.list || [];
          console.log(data);

          for (var i in data) {
            var list = data[i];

            if (list.has_child == 1) {
              // console.log(Vue.version)
              list._loading = false;
              list.parent_code = "0";
              list.parent_name = _this7.$t("nodata"), list.children = [];
            }

            console.log(list);
            vm.tableData.push(list);
          }

          console.log(vm.tableData);
          vm.tabletotallen = res.body.total;
        } else {
          vm.tableData = [];

          _this7.$Message.error(res.errorMsg);
        }
      };

      sn_file_log(this.reqBase).then(function (res) {
        callbak(res);
      }).catch(function (err) {
        _this7.tableLoading = false;
      });
    },

    /**
     * 重置搜索框
     */
    resetSearch: function resetSearch() {
      this.searchReq = {
        mods: []
      };
    },
    okSearch: function okSearch() {
      Object.assign(this.reqBase, this.searchReq); //重置当前页为1

      this.reqBase.page = 1;
      this.$refs.contentBaseRef.initcurrentPage();
      this.init();
    },

    /**
     * 翻页
     */
    pageonChange: function pageonChange(index) {
      this.reqBase.page = index;
      this.getData();
    },

    /**
     * 筛选
     */
    showSearchParel: function showSearchParel() {
      this.$refs.search.expandPanel();
    },
    addChlid: function addChlid(row) {
      var _this8 = this;

      var vm = this;
      var config = {
        loading: true,
        width: 500,
        render: function render(h) {
          return h("div", [h("div", {
            style: {
              display: "flex",
              justifyContent: "space-between"
            }
          }, [h("h3", {
            style: {
              width: "100%",
              paddingBottom: "5px"
            }
          }, _this8.$t("areamenu.addsubordinatearea")), h("icon", {
            props: {
              type: "md-close",
              size: "16"
            },
            style: {
              cursor: "pointer"
            },
            on: {
              click: function click(evt) {
                vm.$Modal.remove();
              }
            }
          })]), h("Divider", {
            style: {
              margin: "8px 0"
            }
          }), h(addCom, {
            ref: "addCom",
            props: {
              _vm: vm,
              $store: vm.$store,
              edit: false,
              parent_code: row.area_code,
              parent_name: row.area_name
            }
          })]);
        },
        onOk: function onOk() {
          var _this = this;

          var obj = this.$refs.addCom;
          obj.checkForm().then(function (res) {
            if (res) {
              area_add(_objectSpread({}, obj.formModel)).then(function (res) {
                var msg = res.errorMsg;

                if (res.result === 0) {
                  var _msg = res.errorMsg;
                  vm.$Message.success(_msg);
                  vm.$Modal.remove();
                  vm.init();
                } else {
                  vm.$Message.error(msg);
                  _this.buttonLoading = false;
                }
              });
            } else {
              _this.buttonLoading = false;
            }
          });
        }
      };
      this.$Modal.confirm(config);
    },
    add: function add() {
      var _this9 = this;

      var vm = this;
      var config = {
        loading: true,
        width: 500,
        render: function render(h) {
          return h("div", [h("div", {
            style: {
              display: "flex",
              justifyContent: "space-between"
            }
          }, [h("h3", {
            style: {
              width: "100%",
              paddingBottom: "5px"
            }
          }, _this9.$t("productModule.guanliansn")), h("icon", {
            props: {
              type: "md-close",
              size: "16"
            },
            style: {
              cursor: "pointer"
            },
            on: {
              click: function click(evt) {
                vm.$Modal.remove();
              }
            }
          })]), h("Divider", {
            style: {
              margin: "8px 0"
            }
          }), h(uploadsnCom, {
            ref: "uploadsnCom",
            props: {
              _vm: vm,
              $store: vm.$store,
              edit: false,
              parent_code: "0",
              parent_name: _this9.$t("nodata"),
              project_codeData: vm.project_codeData
            }
          })]);
        },
        onOk: function onOk() {
          var _this = this;

          var obj = this.$refs.uploadsnCom;
          obj.checkForm().then(function (res) {
            if (res) {
              //提交请求
              var formModel = obj.formModel;
              var formData = new FormData();
              formData.append('filename', formModel.filename);
              formData.append('model_code', formModel.model_code);
              formData.append('project_code', formModel.project_code);
              import_sn(formData).then(function (res) {
                if (res.result === 0) {
                  vm.$Message.success({
                    content: res.errorMsg,
                    duration: 10,
                    closable: true
                  });
                  vm.$Modal.remove();
                  vm.init();
                } else {
                  vm.$Message.error(res.errorMsg, 5);
                  _this.buttonLoading = false;
                }
              });
            } else {
              _this.buttonLoading = false;
            }
          });
        }
      };
      this.$Modal.confirm(config);
    },
    edit: function edit(row) {
      get_token({
        downloadinfo: "out",
        code: "123"
      }).then(function (res) {
        var lang = localStorage.getItem("local") === "en-US" ? "en-us" : "zh-cn";
        window.open("".concat(process.env.NODE_ENV === "development" ? config.baseUrl.dev : process.env.VUE_APP_BUILD === "production" ? config.baseUrl.pro : config.baseUrl.alp, "/index.php/admin/download/download_file?id=").concat(row.id, "&downloadtoken=").concat(res.body.downloadtoken, "&downloadinfo=out&lang=").concat(lang));
      }); // download_life({ id: row.id })
      // let vm = this;
      // let config = {
      //   loading: true,
      //   width: 500,
      //   render: (h) => {
      //     return h("div", [
      //       h(
      //         "div",
      //         { style: { display: "flex", justifyContent: "space-between" } },
      //         [
      //           h(
      //             "h3",
      //             { style: { width: "100%", paddingBottom: "5px" } },
      //             this.$t("areamenu.editarea")
      //           ),
      //           h("icon", {
      //             props: { type: "md-close", size: "16" },
      //             style: {
      //               cursor: "pointer",
      //             },
      //             on: {
      //               click: (evt) => {
      //                 vm.$Modal.remove();
      //               },
      //             },
      //           }),
      //         ]
      //       ),
      //       h("Divider", {
      //         style: {
      //           margin: "8px 0",
      //         },
      //       }),
      //       h(addCom, {
      //         ref: "addCom",
      //         props: {
      //           edit: true,
      //           $store: vm.$store,
      //           _vm: vm,
      //           setData: row,
      //         },
      //       }),
      //     ]);
      //   },
      //   onOk: function () {
      //     let _this = this;
      //     let obj = this.$refs.addCom;
      //     obj.checkForm().then((res) => {
      //       if (res) {
      //         let { area_name, desc, area_code } = obj.formModel;
      //         area_update({ area_name, desc, area_code, type: 1 }).then(
      //           (res) => {
      //             let msg = res.errorMsg;
      //             if (res.result === 0) {
      //               let msg = res.errorMsg;
      //               vm.$Message.success(msg);
      //               vm.$Modal.remove();
      //               vm.init();
      //             } else {
      //               vm.$Message.error(msg);
      //               _this.buttonLoading = false;
      //             }
      //           }
      //         );
      //       } else {
      //         _this.buttonLoading = false;
      //       }
      //     });
      //   },
      // };
      // this.$Modal.confirm(config);
    },
    search: function search() {
      this.onSearch(this.form_filter);
    },
    reset: function reset() {
      this.form_filter = {
        cate_name: null
      };
      this.search();
    },

    /**
     * 删除
     */
    del: function del(row) {
      var vm = this;
      this.$Modal.confirm({
        title: this.$t("delete"),
        content: this.$t("isdelete") + " " + row.filename + " " + this.$t("ma") + "？",
        loading: true,
        onOk: function onOk() {
          var _this = this;

          console.log("rowrow", row);
          del_table_data({
            id: row.id
          }).then(function (res) {
            var msg = res.errorMsg;

            if (res.result === 0) {
              var _msg2 = res.errorMsg;
              vm.$Message.success(_msg2);
              vm.$Modal.remove();
              vm.init();
            } else {
              vm.$Message.error(msg);
              _this.buttonLoading = false;
            }
          });
        }
      });
    }
  },
  mounted: function mounted() {
    this.$set(this.reqBase, "project_code", this.$store.state.user.projectCode);
    this.init();
  },
  created: function created() {},
  destroyed: function destroyed() {
    window.onresize = null;
  }
};